import { Info } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

export const InfoPill = ({ 
  label, 
  value, 
  infoUrl, 
  onClick, 
  style = {},
  showInfoIcon = true,
  disabled = false 
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled || !infoUrl) return;
    
    if (onClick) {
      onClick(infoUrl);
    } else {
      navigate(infoUrl);
    }
  };

  const isClickable = !disabled && infoUrl;

  return (
    <div
      onClick={handleClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        background: '#fff',
        padding: '6px 12px',
        borderRadius: 20,
        border: '1px solid #e8e0e8',
        fontSize: 14,
        color: '#4B164C',
        fontWeight: 500,
        cursor: isClickable ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
        width: 'fit-content',
        maxWidth: '100%',
        ...style
      }}
      onMouseOver={e => {
        if (isClickable) {
          e.currentTarget.style.background = '#f8f6fa';
          e.currentTarget.style.borderColor = '#4B164C';
          e.currentTarget.style.transform = 'translateY(-1px)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(75,22,76,0.15)';
        }
      }}
      onMouseOut={e => {
        if (isClickable) {
          e.currentTarget.style.background = '#fff';
          e.currentTarget.style.borderColor = '#e8e0e8';
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = 'none';
        }
      }}
      title={isClickable ? `En savoir plus sur ${value}` : undefined}
    >
      <span style={{ whiteSpace: 'nowrap' }}>{value}</span>
      {showInfoIcon && isClickable && (
        <Info 
          size={12} 
          color="#4B164C" 
          style={{ flexShrink: 0 }}
        />
      )}
    </div>
  );
}; 